module.exports = __webpack_public_path__ + "img/ccfd816.png";